var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.6317 3C15.7738 3 19.1317 6.35786 19.1317 10.5C19.1317 12.7729 18.1206 14.8096 16.5238 16.185L19.753 19.4142C19.9482 19.6095 19.9482 19.9261 19.753 20.1213C19.5577 20.3166 19.2411 20.3166 19.0459 20.1213L15.7159 16.7914C14.5408 17.5559 13.1381 18 11.6317 18C7.48952 18 4.13165 14.6421 4.13165 10.5C4.13165 6.35786 7.48952 3 11.6317 3ZM11.6317 4C8.0418 4 5.13165 6.91015 5.13165 10.5C5.13165 14.0899 8.0418 17 11.6317 17C15.2215 17 18.1317 14.0899 18.1317 10.5C18.1317 6.91015 15.2215 4 11.6317 4Z"}));
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Search;

Search.default = Search;
